<template>
    <div class="profile_wrap">
        <h5 class="uppercase underline">Configuración de Perfil</h5>
        <form action="#" method="get">
            <div class="form-group">
                <label class="control-label">Nombre completo</label>
                <input
                    class="form-control white_bg"
                    id="fullname"
                    type="text"
                />
            </div>
            <div class="form-group">
                <label class="control-label">Correo electrónico</label>
                <input class="form-control white_bg" id="email" type="email" />
            </div>
            <div class="form-group">
                <label class="control-label">Celular</label>
                <input
                    class="form-control white_bg"
                    id="phone-number"
                    type="text"
                />
            </div>
            <div class="form-group">
                <label class="control-label">Ciudad</label>
                <input class="form-control white_bg" id="city" type="text" />
            </div>
            <div class="form-group">
                <label class="control-label">Ubicación</label>
                <textarea class="form-control white_bg" rows="2"></textarea>
            </div>            
            <div class="gray-bg field-title">
                <h6>Actualizar Constraseña</h6>
            </div>
            <div class="form-group">
                <label class="control-label">Contraseña</label>
                <input
                    class="form-control white_bg"
                    id="password"
                    type="password"
                />
            </div>
            <div class="form-group">
                <label class="control-label">Confirmar Contraseña</label>
                <input
                    class="form-control white_bg"
                    id="c-password"
                    type="password"
                />
            </div>
            <div class="gray-bg field-title">
                <h6>Links Redes Sociales</h6>
            </div>
            <div class="form-group">
                <label class="control-label">ID Facebook</label>
                <input
                    class="form-control white_bg"
                    id="facebook"
                    type="text"
                />
            </div>
            <div class="form-group">
                <label class="control-label">ID Twitter</label>
                <input class="form-control white_bg" id="twitter" type="text" />
            </div>
            <div class="form-group">
                <label class="control-label">ID Instagram </label>
                <input
                    class="form-control white_bg"
                    id="linkedin"
                    type="text"
                />
            </div>
            <div class="form-group">
                <button type="submit" class="btn">
                    Guardar Cambios
                    <span class="angle_arrow"
                        ><i class="fa fa-angle-right" aria-hidden="true"></i
                    ></span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
